/**
 * Jay@airwhizz.com
 * Description :
 *
 * @input :
 * @output :
 *
 *
 */
import React, {Component} from 'react';
import {AutoComplete, Button, Card, Form, Icon, Input, Popover, Select, Spin, Tag, Upload} from 'antd';

import {connect} from "react-redux";
import {uploadPmChecklist} from "../../appRedux/actions/ServiceIdentifier";

const {Search} = Input;

class ChecklistImport extends Component {
  state = {
    fileList: [],
    uploading: false,
    selectedModel: null,
    modelsWithSearch: [],
  };
  handleUpload = () => {
    const {fileList} = this.state;
    const formData = new FormData();
    // fileList.forEach(file => {
    formData.append('file', fileList[0]);
    formData.append('model', this.state.selectedModel);
    // });
    this.setState({
      uploading: true,
    });
    this.props.uploadPmChecklist(formData);
  };

  UNSAFE_componentWillReceiveProps(nextProps, _) {
    if (nextProps && JSON.stringify(nextProps.loading) && JSON.stringify(this.props.loading) !== JSON.stringify(nextProps.loading)) {
      this.setState({
        uploading: nextProps.loading,
      });
    }
  }

  templateContent = (
    <div>
      <p>CSV file template</p>
      <Button size={'small'} onClick={() => {
        window.open('../csv_template/scheduleTemplate.csv', '_blank');
      }}>Download</Button>
    </div>
  );

  handleModelSearch = (keyword) => {
    if (keyword) {
      // console.log(keyword)
      const {model} = this.props.filters || {};
      if (model) {
        const {data} = model;
        if (data && data.data) {
          const models = data.data || [];
          this.setState({modelsWithSearch: models.filter(obj => obj.name.toLowerCase().includes(keyword.trim().toLowerCase()))})
        }
      }
    }
  }

  handleModelSelect = (model) => {
    if (model)
      this.setState({selectedModel: model})
  }

  render() {
    const {uploading, fileList, modelsWithSearch, selectedModel} = this.state;
    // console.log(modelsWithSearch)
    // console.log(selectedModel)
    const props = {
      accept: "text/csv",
      onRemove: file => {
        this.setState(state => {
          const index = state.fileList.indexOf(file);
          const newFileList = state.fileList.slice();
          newFileList.splice(index, 1);
          return {
            fileList: newFileList,
          };
        });
      },
      beforeUpload: file => {
        this.setState(state => ({
          fileList: [...state.fileList, file],
        }));
        return false;
      },
      fileList,
    };
    return (
      <div>
        <Card title={`Schedule Maintenance import `}>
          <AutoComplete
            showSearch
            style={{width: "100%", marginBottom: '50'}}
            placeholder="Please select Model"
            // notFoundContent={this.props.loading ? <Spin size="small"/> : null}
            // filterOption={(input, option) =>
            //   (option.props.label + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
            // }
            onSearch={this.handleModelSearch}
            onSelect={this.handleModelSelect}
          >
            {modelsWithSearch.map(mdl => (
              <Select.Option key={mdl._id} value={mdl._id}>{mdl.name}</Select.Option>
            ))}
          </AutoComplete>
          <Upload {...props}>
            <Button>
              <Icon type="upload"/> Select File (CSV) to upload
            </Button>
          </Upload>
          <Button
            type="primary"
            onClick={this.handleUpload}
            disabled={fileList.length === 0}
            loading={uploading}
            style={{marginTop: 16}}
          >
            {uploading ? 'Uploading' : 'Start Upload'}
          </Button>
          <Popover content={this.templateContent} title="" trigger="click">
            <Button type="default" shape="circle" icon="download" size={'small'}/>
          </Popover>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = ({auth, jobCard, commonData}) => {
  return {
    authUser: auth.authUser,
    // searchData: jobCard.searchData,
    // resource: jobCard.resource,
    loading: commonData.loading,
    // filters: commonData.filters,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    // fetchFilter,
    // searchResource,
    uploadPmChecklist
  };
}

const ChecklistUpload = Form.create({name: 'job-card-search'})(ChecklistImport);
export default connect(mapStateToProps, mapDispatchToProps())(ChecklistUpload);
